<div class="modal-content modal-content-right" role="dialog" aria-label="Import">
  <div class="modal-header">
    <div class="row">
      <h1 class="modal-title col-sm-7"  aria-label="Title">{{ uploadStep == 1 ? 'Import Type' : 'Import Records' }}</h1>
      <div class="col-sm-5 text-right helpdesk px-3"><a [href]="getHowToLink()" target="_blank"><i class="far fa-question-circle"></i><small class="hidden">Learn How To Import</small></a></div>
    </div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" role="main">
    <div [ngClass]="{'upload-step': true, 'active': uploadStep== 1 }">
      <div class="row">
        <div class="col-md-12">
          <div style="padding:15px;margin-bottom:1.5em;cursor:pointer;min-height:100px;" [ngClass]="{'upload-option': true, 'selected': uploadtype== 1 }" (click)="selectOption(1)">
            <div class="row">
              <div class="col-md-1" [ngClass]="{'upload-option-checked': uploadtype == 1, 'upload-option-unchecked' : uploadtype == 2}">
                <i style="font-size:24px; color: #ce1025; margin-top:15px;" [ngClass]="{'fas' : true, 'fa-check-circle' : true }"></i>
              </div>
              <div class="col-md-10">
                <p style="margin-bottom:1px;">
                  <strong>Modify Records</strong>
                </p>
                <small data-test-option-label-text="secondary" id="ember1381"> Add new records and update existing ones. Existing records will be revised, not deleted.</small>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row" *ngIf="false" >
        <div class="col-md-12">
          <div [ngClass]="{'upload-option': true, 'selected': uploadtype== 2 }" (click)="selectOption(2)">
            <div class="row">
              <div class="col-md-1" [ngClass]="{'upload-option-checked': uploadtype == 2, 'upload-option-unchecked' : uploadtype == 1}">
                <i style="font-size:24px; color: #ce1025; margin-top:15px;" [ngClass]="{'fas' : true, 'fa-check-circle' : true }"></i>
              </div>
              <div class="col-md-10">
                <p style="margin-bottom:1px;">
                  <strong>Replace Records </strong>
                </p>
                <small data-test-option-label-text="secondary" id="ember1382">  Overwrite existing records. All items will be deleted and replaced.</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <small><i class="fas fa-stop text-danger"></i> - The allowed maximum number of records should not exceed 500. CSV File with rows over 500 will not be processed.  </small>
        </div>
      </div>
    </div>
    <div [ngClass]="{'upload-step': true, 'active': uploadStep== 2 }">
      <label class="font-weight-bold" for="headerRowIndex">For Non-default Template Only:</label>
      <br>
      <div class="row">
        <div class="col-md-4">
          <div class="custom-checkbox">
            <input type="checkbox" [(ngModel)]="noRowHeader" (change)="hasHeaderChange($event)" id="NoColumnHeader">
            <label class="custom-control-label" for="NoColumnHeader">No Column Header</label>
          </div>
        </div>
        <!-- <div class="col-md-8">
        <label class="label-chk">Row Number of the Column Header</label>
          <input type="number" class="form-control" id="headerRowIndex" (change)="headerRowChanged($event)" name="headerRowIndex" [(ngModel)]="headerRowIndex" min="1" placeholder="1" [disabled]="noRowHeader">
        </div> -->
      </div>
    </div>
    <hr>
    <div [ngClass]="{'upload-step': true, 'active': uploadStep== 2 }">
      <div class="row">
        <div class="col-md-12">
          <div style="padding:15px;margin-bottom:1.5em;cursor:pointer;min-height:100px;" [ngClass]="{'upload-option': true, 'selected': true }" (click)="openFileBrowser()">
            <div class="row">
            <div class="col-md-1">
              <i style="font-size:24px; margin-top:15px;" [ngClass]="{'fas' : true, 'fa-file-csv' : true }"></i>
            </div>
            <div class="col-md-10">
              <p style="margin-bottom:1px;">
                <strong>Upload CSV</strong>
              </p>
               <small data-test-option-label-text="secondary" id="ember1383"> Select csv file from your computer</small>
            </div>
            <div class="form-group" style="display:none;">
                <input type="file"
                       id="csvFile" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                       (change)="onCsvFileSelected($event)">
            </div>
          </div>
          </div>
          <div class="text-right" *ngIf="processingFile">
            <small>
                Processing File... <span><i class="fas fa-spinner fa-spin"></i></span>
            </small>
          </div>
          <div class="text-right" *ngIf="hasUploadError">
             <small class="text-danger">
               <i class="fas fa-exclamation-triangle"></i> {{uploadMessage}}
            </small>
          </div>
        </div>
      </div>

    </div>



  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-outline" (click)="step()" *ngIf="uploadStep == 1">
      <i class="fas fa-arrow-right"></i>
       Next
    </button>
    <button type="button" class="btn btn-outline" (click)="step()" *ngIf="uploadStep == 2 && type != 'customer'">
      <i class="fas fa-arrow-left"></i>
       Back
    </button> -->
    <button type="button" class="btn btn-outline" (click)="close()">
      <!-- <i class="fas fa-times"></i> -->
      Cancel
    </button>
  </div>
</div>
